export default {
    organization_public: 'a1.x45',
}